import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../../utils/helpers';
import './SelectedTeamPokerRunning.css';

const SelectedTeamPokerRunning = ({ team, contest }) => {

  // --- Hooks must be called before conditional returns --- 

  // Player Data Map (Finish, Cashed, Salary, Chip Count, Initial Chip Count)
  const playerDataMap = useMemo(() => {
    console.log('Debug - SelectedTeam - Raw players:', contest.players);
    const map = {};
    contest.players.forEach(player => {
      map[player.name] = { 
        finish: player.finish, 
        cashedFor: player.cashedFor, 
        salary: player.salary, // Include salary
        // Add chip counts
        currentChipCount: player.sportSpecificData?.currentChipCount, 
        chipCount: player.sportSpecificData?.chipCount // Add initial chip count
      };
      console.log(`Debug - SelectedTeam - Player ${player.name}:`, {
        finish: player.finish,
        cashedFor: player.cashedFor,
        currentChipCount: player.sportSpecificData?.currentChipCount
      });
    });
    return map;
  }, [contest.players]);

  // Calculate Total Team Cashes
  // const totalTeamCashes = useMemo(() => {
  //   if (!team) return 0;
  //   let total = 0;
  //   const captainCashed = playerDataMap[team.team.captain]?.cashedFor || 0;
  //   total += captainCashed * 2;
  //   team.team.flexPlayers.forEach(player => {
  //     total += playerDataMap[player]?.cashedFor || 0;
  //   });
  //   return total;
  // }, [playerDataMap, team]);

  // --- Conditional return --- 
  if (!team) return null;

  // --- Logic that depends on team --- 

  // Format chip count for display
  const formatChipCount = (chips) => {
    // Formatting logic assumes chips is the final value to display
    if (chips === null || chips === undefined) return '-'; // No data for either
    if (chips === 0) return 'BUST';
    if (chips === -1) return 'DNP';
    if (chips > 0) return formatNumber(chips); // Format positive numbers
    return '-'; // Fallback for unexpected values
  };

  // Get salaries for display (using the map)
  const captainSalary = playerDataMap[team.team.captain]?.salary || 0;
  const flexPlayerSalaries = team.team.flexPlayers.map(
    player => playerDataMap[player]?.salary || 0
  );

  return (
    <div className="selected-team-container-poker">
      <div className="selected-team-header">
        <h2>{team.entryName || team.username}'s Team</h2>
      </div>
      <div className="selected-team-content">
        <table className="selected-team-table">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Name</th>
              <th>Salary</th>
              <th>Chips</th>
              <th>Cashed</th>
            </tr>
          </thead>
          <tbody>
            {(() => { // Captain Row
              const captainData = playerDataMap[team.team.captain];
              const captainCashed = captainData?.cashedFor || 0;
              const captainCurrentChips = captainData?.currentChipCount;
              const captainInitialChips = captainData?.chipCount;
              // Determine chips to display for formatting
              const captainChipsToDisplay = (captainCurrentChips === null || captainCurrentChips === undefined) 
                                          ? captainInitialChips 
                                          : captainCurrentChips;
              // Determine ROW status class based on chips
              const rowStatusClass = (captainChipsToDisplay === 0 || captainChipsToDisplay === -1) 
                                  ? 'player-eliminated' 
                                  : 'player-active'; 

              return (
                <tr>
                  <td><span className="position-label position-label--cpt">CPT*</span></td>
                  <td className={`captain-cell ${rowStatusClass}`}>
                    {team.team.captain}
                  </td>
                  <td className={rowStatusClass}>${formatNumber(captainSalary)}</td>
                  <td className={rowStatusClass}>{formatChipCount(captainChipsToDisplay)}</td> 
                  <td className={`${rowStatusClass} cashed-amount`}>
                    {captainCashed > 0 ? (
                      <>
                        ${formatNumber(captainCashed)} 
                        {/* <span className="captain-bonus-indicator"></span> */}
                      </>
                    ) : (
                      <>
                        ${formatNumber(0)}
                        {/* <span className="captain-bonus-indicator"></span> */}
                      </>
                    )}
                  </td>
                </tr>
              );
            })()}
            {team.team.flexPlayers.map((player, index) => { // Flex Player Rows
              const playerData = playerDataMap[player];
              const playerCashed = playerData?.cashedFor || 0;
              const playerSalary = flexPlayerSalaries[index];
              const playerCurrentChips = playerData?.currentChipCount;
              const playerInitialChips = playerData?.chipCount;
               // Determine chips to display for formatting
              const playerChipsToDisplay = (playerCurrentChips === null || playerCurrentChips === undefined) 
                                          ? playerInitialChips 
                                          : playerCurrentChips;
              // Determine ROW status class based on chips
              const rowStatusClass = (playerChipsToDisplay === 0 || playerChipsToDisplay === -1) 
                                  ? 'player-eliminated' 
                                  : 'player-active';

              return (
                <tr key={index}>
                  <td><span className="position-label">FLEX</span></td>
                  <td className={`flex-cell ${rowStatusClass}`}>
                    {player}
                  </td>
                  <td className={rowStatusClass}>${formatNumber(playerSalary)}</td>
                  <td className={rowStatusClass}>{formatChipCount(playerChipsToDisplay)}</td>
                  <td className={`${rowStatusClass} cashed-amount`}>
                    {playerCashed > 0 ? (
                      <>
                        ${formatNumber(playerCashed)} 
                        {/* <span className="captain-bonus-indicator"></span> */}
                      </>
                    ) : (
                      <>
                        ${formatNumber(0)}
                        {/* <span className="captain-bonus-indicator"></span> */}
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

SelectedTeamPokerRunning.propTypes = {
  team: PropTypes.object.isRequired,
  contest: PropTypes.shape({
    players: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      finish: PropTypes.number,
      cashedFor: PropTypes.number,
      salary: PropTypes.number,
      sportSpecificData: PropTypes.shape({ 
        currentChipCount: PropTypes.number, // Add chip count
        chipCount: PropTypes.number // Add initial chip count
      })
    })).isRequired
  }).isRequired
};

export default SelectedTeamPokerRunning;